import { useEffect }              from 'react'
import { _bootstrap }             from 'state/store.bootstrap'
import { _project }               from 'state/store.projects'
import { active_project }         from 'state/store.global'
import { useFetch }               from 'hooks/fetch/useFetch'
import { useGet, setFocus, get }       from 'state/jotai'
import { array }                  from 'utilities/utility.misc'
import { preloadImage }           from 'utilities/utility.images'
import { ISO_FRAMES, ISOPARENT_CONFIG } from 'api/api'
import eachOfLimit                from 'async/eachOfLimit'
import { _lowerQualityIsometry } from 'state/store.lowerQualityIsometry'
import { _parentIsometry } from 'state/store.parentIsometry'

export const PreloadParentIsoFrames = () => {

  const { pin, pid } = useGet(active_project)

  const cache  = useGet(_parentIsometry).status
  const url    = pid ? ISOPARENT_CONFIG : null
  const config = useFetch({ url:url ? url : null }).D

  const setFrames  = setFocus(_parentIsometry, 'frames')
  const setPercent = setFocus(_parentIsometry, 'percent')
  const setStatus  = setFocus(_parentIsometry, 'status')
  const setConfig  = setFocus(_parentIsometry, 'config')

  const isometryToggle     = get(_parentIsometry, 'toggle');

  useEffect(()=>{
    //  console.log(config, pin, isometryToggle, cache)
    if (isometryToggle && config && pin >= 0 && !['FETCHING','DONE'].includes(cache[pin][pid]) ) {
       
        const x       = config[pin]
          
        const ARR     = []
        const PATH    = x.PNG_PATH
        const NUM     = x.IMAGE_NUM
        const IMG_INI = x.FIRST_IMAGE
        const IMG_END = x.LAST_IMAGE
        const INI     = x.START_IMAGE
        const SNP     = x.IMAGE_SNAPFRAMES
        const EXT     = x.FILE_EXT
      
        const FNC  = x => {
          if(INI + x > IMG_END) {
            return `${ISO_FRAMES}${PATH}/${Math.abs(IMG_END - (INI + x)) + IMG_INI - 1}.${EXT}`
          }else {
            return `${ISO_FRAMES}${PATH}/${x + INI}.${EXT}`
          }
        }
        
        const COL = array(NUM, FNC, SNP)
        
        setConfig ( a => a?.map((d,i)=>fn(d,i,pin,pid,x)) )
        eachOfLimit(COL, 20, 
          ( val, idx, callback ) => {
            const IMG     = preloadImage(val)
            const STATUS  = ( idx !== NUM - 1 ) ? 'FETCHING' : 'DONE'
            const PERCENT = ( idx * ( 100 / NUM ) ).toFixed()
            
            ARR[idx] = { [IMG_INI+idx]:IMG }
            setFrames ( a => a?.map((d,i)=>fn(d,i,pin,pid,ARR     )) )
            setPercent( a => a?.map((d,i)=>fn(d,i,pin,pid,PERCENT )) )
            setStatus ( a => a?.map((d,i)=>fn(d,i,pin,pid,STATUS  )) )
            IMG.onload = ( ) => callback()
          },
          () => {
                  // console.log( 'Done preloading frames for', pin, pid )
          }
        )
            // })
    }
  },[config, pin, pid])
  return null
}
const fn = (x,y,z,v,w) => (y===z) ? { [v] : w } : x